<div class="user-list-shell">
  <div class="list-header">
    <h5>All App Users</h5>
    <div class="list-filters">
      <input
        type="text"
        class="form-control form-control-sm search-input"
        placeholder="Search by name, username, email, mobile..."
        [(ngModel)]="searchTerm"
        (input)="onSearchChange()"
      />
      <select
        class="form-select form-select-sm last-seen-filter"
        [(ngModel)]="lastSeenFilter"
        (change)="onLastSeenFilterChange()"
      >
        <option value="all">Last seen: All</option>
        <option value="24h">Last 24 hours</option>
        <option value="7d">Last 7 days</option>
        <option value="30d">Last 30 days</option>
        <option value="never">Never/Invalid</option>
      </select>
    </div>
  </div>

  <kendo-grid
    [kendoGridBinding]="filteredItems"
    [height]="560"
    [pageSize]="20"
    [skip]="skip"
    (pageChange)="onPageChange($event)"
    [pageable]="true"
    [sortable]="true"
    [filterable]="true"
  >
    <kendo-grid-column [width]="90" title="Photo">
      <ng-template kendoGridCellTemplate let-dataItem>
        <img
          class="user-thumb"
          [src]="dataItem.profilePicture || defaultUserImage"
          (error)="onImageError($event)"
          alt="Profile"
        />
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="firstName" title="First name"> </kendo-grid-column>
    <kendo-grid-column field="email" title="Email"></kendo-grid-column>
    <kendo-grid-column field="mobileNo" title="Mobile"></kendo-grid-column>
    <kendo-grid-column [width]="130" title="Status">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [class]="getActiveStatusClass(dataItem.active)">
          {{ dataItem.active ? 'Active' : 'Inactive' }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [width]="160" title="Last Seen">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ formatLastSeen(dataItem.lastSeenTs) }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="totalConnections" title="Total Connections"></kendo-grid-column>
    <kendo-grid-column [width]="100" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" (click)="showUserDetails(dataItem)">
          View
        </button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridLoadingTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>
  </kendo-grid>
</div>